import React from 'react'
import {motion} from 'framer-motion'
import ConnectionForm from './ConnectionForm'
import { useState } from 'react';

function PlanCard({title, speed, prices, features, connection, setConnection}) {
     const [duration, setDuration] = useState(12);
    const handleDurationChange = (e) => {
        setDuration(e.target.value);
    }   
  return (
    <>
    <motion.div className="bg-white shadow-lg border-2 border-gray-700 shadow-gray-700 rounded-lg transition-transform duration-300 hover:scale-105 " initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.2, ease: "easeOut" }}>
                <div className="border-b-2 border-b-gray-800 bg-gray-800">
                <h2 className="text-xl font-bold p-3 text-center text-white">{title}</h2>
                </div>
                <div className="flex justify-between items-center m-2">
                <p className="text-blue-950 text-xl font-bold">Rs. {prices[duration]}</p>
                <select className="text-gray-800" onChange={handleDurationChange} value={duration}>
                    <option value="12" >12 months</option>
                    <option value="3" >3 months</option>
                    <option value="1" >1 month</option>
                </select>
                </div>
                <h2 className="text-3xl font-bold text-center text-blue-950 p-2">{speed}</h2>
                <div className="flex flex-col justify-center items-start p-4">
                    { features.map((feature, idx)=>(
                    <div key={idx} className="flex items-center gap-2">
                    {feature.icon}
                    <p className="text-gray-800">{feature.text}</p>
                    </div>
                ))}
                </div>
                <div className="flex flex-col justify-center items-center m-4">
                <button className="bg-green-600 text-white text-xl rounded-lg p-1 font-inter" onClick={()=>setConnection(!connection)}>Order Now</button>
                <p className="underline underline-offset-2 decoration-gray-800 text-sm m-2 cursor-pointer">More Details</p>
                </div>
            </motion.div>
            { connection && <ConnectionForm setConnection={setConnection} /> }
  </>
  )
}

export default PlanCard;